import { Injectable, Injector } from '@angular/core';

import { ClientConfigProductName, ProductService } from '@frontend/vanilla/core';

@Injectable({
    providedIn: 'root',
})
export class PokerProductService {
    constructor(
        private productService: ProductService,
        private injector: Injector,
    ) {}

    activatePoker(): void {
        if (!this.productService.isSingleDomainApp) {
            return;
        }
        if (!this.productService.getMetadata(ClientConfigProductName.POKER).isRegistered) {
            this.injector.get(ProductService).register(ClientConfigProductName.POKER, this.injector);
        }
        this.productService.setActive(ClientConfigProductName.POKER);
    }

    deactivatePoker(): void {
        if (!this.productService.isSingleDomainApp) {
            return;
        }
        this.productService.deactivateProduct(ClientConfigProductName.POKER);
    }
}
